import { render, staticRenderFns } from "./MyProfileNew.vue?vue&type=template&id=3c966a46&scoped=true"
import script from "./MyProfileNew.vue?vue&type=script&lang=js"
export * from "./MyProfileNew.vue?vue&type=script&lang=js"
import style0 from "./MyProfileNew.vue?vue&type=style&index=0&id=3c966a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c966a46",
  null
  
)

export default component.exports